import { TagERP, TagType } from "@finanedi.es/storybook"
import { GetPrestamoByFiltersDtoProps } from "api/DTOs/GetPrestamoByFiltersDto"
import { ESTADO_PRESTAMO, EstadoPrestamoType } from "api/Types/EstadoPrestamo"
import { TFunction } from "i18next"

export const estadoPrestamoVariants = (
  t: TFunction
): Record<EstadoPrestamoType, { label: string; color: TagType }> => ({
  [ESTADO_PRESTAMO.PENDIENTE]: {
    label: t("prestamos.state.penddingLabel"),
    color: "warning",
  },
  [ESTADO_PRESTAMO.EN_PROGRESO]: {
    label: t("prestamos.state.inProgressLabel"),
    color: "info",
  },
  [ESTADO_PRESTAMO.COMPLETADO]: {
    label: t("prestamos.state.completLabel"),
    color: "success",
  },
})

export const EstadoPrestamo = ({
  variant,
  id,
  t,
}: {
  variant?: EstadoPrestamoType
  id?: GetPrestamoByFiltersDtoProps["id"]
  t: TFunction
}): JSX.Element => {
  const { label, color } =
    estadoPrestamoVariants(t)[variant ?? ESTADO_PRESTAMO.PENDIENTE]

  return (
    <div
      className='tw-flex tw-justify-center tw-items-center !tw-w-full tw-whitespace-nowrap'
      data-testid='Prestamo_Estado'
    >
      <TagERP
        id={id}
        value={label}
        color={color}
      />
    </div>
  )
}
